export default __webpack_public_path__ + "static/media/Presidentialdick.05dc9bc9.png";